<template>
  <el-card >
    <!-- 查询条件表单 -->
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="姓名:"  >
        <el-input v-model="searchFactor.fullName"  style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="用户名:">
        <el-input v-model="searchFactor.usrName" style="width:150px"></el-input>
      </el-form-item>
      <el-form-item label="角色:" >
      <el-select v-model="searchFactor.roleName" placeholder="请选择" style="width:150px">
        <el-option
          v-for="item in roleNameOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="状态:" >
      <el-select style="width: 100px" v-model="searchFactor.actState" placeholder="请选择" >
        <el-option
          v-for="item in actStateOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="团队:" >
      <el-select v-model="searchFactor.deptId" placeholder="请选择" >
        <el-option
          v-for="item in deptOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSearch">查询</el-button>
      <el-button type="primary" @click="templateDownLoad">模板下载</el-button>
      <el-button type="primary" @click="handleCreateUser">创建用户</el-button>
      <el-upload
        style="display: inline-block"
        ref='upload'
        :action="userInfoFile.url"
        :headers="userInfoFile.headers"
        :multiple="false"
        :limit="userInfoFile.limit"
        :name="userInfoFile.file"
        :on-success="fileUpLoadSuccess"
        :show-file-list="false"
        :on-error="fileUpLoadError">
        <el-button type="primary" >导入</el-button>
      </el-upload>
    </el-form-item>
    </el-form>
    <!-- 用户表格 -->
    <el-table
      :data="tableData"
      ref ="multipleTable"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%"
      class="tableClass">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column min-width="100px" prop="picture" label="头像">
        <template slot-scope="scope">
          <img :src="scope.row.headImgUrl" fit="fill"  height="70"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="fullName"
        label="姓名"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="usrName"
        label="用户名"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="mobilePhone"
        label="手机"
        min-width="180">
      </el-table-column>
      <el-table-column
      prop="email"
        label="邮件"
        min-width="180">
      </el-table-column>
      <el-table-column
        prop="deptName"
        min-width="200"
        label="团队">
      </el-table-column>
      <el-table-column
        prop="gentle"
        min-width="50"
        label="性别" :formatter="formatGentle">
      </el-table-column>
      <el-table-column
        prop="active"
        min-width="70"
        label="状态" >
        <template slot-scope="scope">
          <span v-if = "scope.row.active == 1" style="color: greenyellow">  激活</span>
          <span v-else  style="color: red" > 禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="roleNames"
        min-width="200"
        label="角色">
      </el-table-column>
      <el-table-column
        prop="createUsr"
        width="100"
        label="创建者">
      </el-table-column>
      <el-table-column
        prop="createTime"
        min-width="120"
        label="创建时间">
      </el-table-column>
      <el-table-column label="操作"  min-width="120px" >
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"active",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 1 ? 'el-icon-star-off':'el-icon-star-on' "  :style="scope.row.active == 1 ? 'color:rgb(246, 102, 18)':'color:rgb(40, 238, 10)'" ></i> 
                <span>{{scope.row.active == 1?'禁用':'激活'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"signRole",index:scope.$index, data:scope.row}'> <i class="el-icon-user-solid" style="color:rgb(39, 193, 231)" ></i> <span>分配角色</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"resetPass",index:scope.$index, data:scope.row}'><i class="el-icon-key" style="color:rgb(41, 10, 239)" ></i> <span>重置密码</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"edit",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(40, 238, 10)" ></i> <span>修改信息</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页插件 -->
    <el-pagination
      background
      height="200px"
      layout="total,prev, pager, next"
      :current-page.sync="pager.currentPage"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin:10px">
    </el-pagination>
    <!-- 编辑用户弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.editUserInfoDialogVisible" v-on:close ="clearEditUserInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 用户{{ userInfoForm.usrName }} 信息变更 </span>
      </div>
      <el-form  label-width="20%"  :model="userInfoForm">
        <el-col :span="24">
            <el-form-item label="更新头像:" label-width="10%"  style="width:100%">
            <el-switch
              v-model="userInfoForm.updateImage"
              active-text="是"
              inactive-text="否"  @change ="funcUpdateImageChange">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item  label-width="10%"  label="头像:" style="width:100%" >
            <el-upload
            :action="'#'"
            list-type="picture-card"
            :auto-upload="false"
            :ref="userInfoForm.refElUpload"   
            :file-list="userInfoForm.fileList" 
            :limit="userInfoForm.limit">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file,userInfoForm.refElUpload)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item  label="姓名:">
            <el-input v-model="userInfoForm.fullName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item  label="性别:">
            <el-select  style="width: 100%" v-model="userInfoForm.gentle" placeholder="请选择">
              <el-option
                v-for="item in genderArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机:">
            <el-input  v-model="userInfoForm.mobilePhone" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱:">
            <el-input v-model="userInfoForm.email" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="团队:"  >
            <el-select  v-model="userInfoForm.deptId" style="width:100%" placeholder="请选择" >
              <el-option
                v-for="item in deptOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureChange">确定变更</el-button>
      </div>
    </el-dialog>
     <!-- 创建用户弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.createUserInfoDialogVisible" v-on:close ="clearCreateUserInfoForm" >
      <div slot="title" class="dialog-footer">
        <span> 创建用户信息 </span>
      </div>
      <el-form :model="createUserInfoForm" label-width="20%">
        <el-col :span="24">
          <el-form-item  label-width="10%"  label="头像:" style="width:100%" >
            <el-upload
            :action="'#'"
            list-type="picture-card"
            :auto-upload="false"
            :ref="createUserInfoForm.refElUpload"    
            :limit="createUserInfoForm.limit">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file,createUserInfoForm.refElUpload)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item  style="width: 100%" label="姓名:">
            <el-input  v-model="createUserInfoForm.fullName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item style="width: 100%" label="用户名:">
            <el-input  v-model="createUserInfoForm.usrName" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:">
            <el-select style="width:100%" v-model="createUserInfoForm.gentle" placeholder="请选择">
              <el-option
                v-for="item in genderArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机:">
            <el-input  v-model="createUserInfoForm.mobilePhone" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱:">
            <el-input v-model="createUserInfoForm.email" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="团队:"  >
            <el-select style="width:100%" v-model="createUserInfoForm.deptId" placeholder="请选择" >
              <el-option
                v-for="item in deptOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建用户</el-button>
      </div>
    </el-dialog>
     <!-- 分配角色弹窗 -->
    <el-dialog :close-on-click-modal="false" width="30%" :visible.sync="dialogVisual.signRoleDialogVisible" v-on:close ="clearSingRoleInfoFrom" >
      <div slot="title" class="dialog-footer">
        <span> 分配角色信息 </span>
      </div>
      <el-table
        ref="multipleTable"
        :data="asignRoleInfoForm.roleList"
        :stripe ="true"
        :border = "true"
        :highlight-current-row ="false"
        :max-height="400"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        @selection-change="handleSelectionChange"
        style="width: 100%; overflow:scroll !important">
        <el-table-column
          type="selection"
          width="55" >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureSign()">确定分配</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty,regCheck,getToken} from  '@/api/utils'
import {PAGE_SIZE,MESSAGE_DURATION,roleType,
  GENDER_ARR,usrNameReg, regEmail,regMobilePone} from  '@/api/constant'

export default {
  name : 'pc_ctr_user',
  data() {
    return {
      genderArr: GENDER_ARR,
      actStateOptions:[
        {  
          value: '',
          label: '全部'
        },
        {  
          value: '0',
          label: '禁用'
        },
        { 
            value: '1',
            label: '激活'
        }
      ],
      roleNameOptions:[
       { 
          value: '',
          label: '全部'
        },
        {  
          value: 'usr',
          label: '普通用户'
        },

        {  
          value: 'admin',
          label: '超级管理员'
        }
      ],
      deptOptions: [],
      searchFactor: {
        fullName: '',
        usrName: '',
        actState: '',
        roleName:'',
        deptId :''
      },
      tableData: [],
      pager:{
        currentPage: 0,
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      dialogVisual:{
        editUserInfoDialogVisible: false,
        createUserInfoDialogVisible: false,
        signRoleDialogVisible:false
      },
      userInfoForm: {
        updateImage:false,
        fullName: '',
        usrName: '',
        deptId : '',
        gentle :'',
        email :'',
        mobilePhone :'',
        fileList:[],
        id : '',
        refElUpload :"userImagUpload",
        limit : 1,
        row : ''
      },
      createUserInfoForm: {
        fullName: '',
        usrName: '',
        roleName:'',
        deptId : '',
        gentle :'',
        email :'',
        mobilePhone :'',
        refElUpload :"userImagEdit",
        limit : 1
      },
      asignRoleInfoForm:{
        roleList:[],
        multipleSelection: [],
        asignUserInfo:''
      },
      userInfoFile:{
        headers: {token:""},
        url : "/bc/exa/usr/upload",
        limit : 1,
        name :"file"
      }
    }
  },
  
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'delete' :
          this.handleDelete(index,row)
          break
        case 'active' :
          this.handleActive(index,row)
          break
        case 'edit' :
          this.handleEdit(index,row)
          break
        case 'resetPass':
          this.restPass(index,row)
          break
        case 'signRole':
          this.handleRole(index,row)
          break
      }
    },
    // 生成表格编号
    indexMethod(index){
      return index+1
    },
    // 格式化性别字段
    formatGentle(row, index){
      if(row.gentle == 1){
        return '男'
      }else{
        return '女'
      }
    },
    
    // 加载用户列表
    userListLoad(pageNo){
      let url = "/bc/exa/usr/usrPage"
      let { 
        fullName,
        usrName,
        actState,
        roleName,
        deptId 
      } =  this.searchFactor 
      
      let dat0 = {
        pageSize: PAGE_SIZE,
        fullName,
        usrName,
        actState,
        roleName,
        deptId ,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.tableData = [];
            dat.data.forEach(t=>this.tableData.push(t))
            this.pager.totalCount = dat.totalDataCount;
              if(pageNo == 1 ) {
                this.pager.currentPage = 1
              }
            } else {
              this.$message({
              showClose: true,
              message: '未查询到用户信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) =>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    // 加载团队清单
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            this.deptOptions.splice(0)
            this.deptOptions.push({value: "",label: '全部' })
            response.data.data.forEach(t=>{
              this.deptOptions.push({value: t.id,label: t.deptName })
            })
          }else{
            this.$message({
              showClose: true,
              message: '团队列表未查询到数据！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    // 查询用户列表
    onSearch(){
      this.userListLoad(1)
    },
    // 打开创建用户弹框
    handleCreateUser(){
      this.dialogVisual.createUserInfoDialogVisible = true
    },
    // 创建用户合法性减产
    ensureCreate(){
      try{ 
        let fileRef = this.$refs[this.createUserInfoForm.refElUpload]
        if(fileRef == null ){
          throw "请上传用户头像"
        }
        let fileList = fileRef.uploadFiles
        if(fileList == null || fileList.length == 0) {
          throw "请上传用户头像"
        }
        stringIsNullOrEmpty(this.createUserInfoForm.fullName,'请输入姓名!');
        stringIsNullOrEmpty(this.createUserInfoForm.usrName,'请输入用户名!');
        regCheck(usrNameReg, this.createUserInfoForm.usrName,'用户名格式不正确,格式为4到16位大小写字母或者数字的组合!');
        stringIsNullOrEmpty(this.createUserInfoForm.mobilePhone,'请输入手机号!');
        regCheck(regMobilePone, this.createUserInfoForm.mobilePhone,'手机号码格式不正确!');
        //stringIsNullOrEmpty(this.createUserInfoForm.email,'请输入邮箱!');

        if(this.createUserInfoForm.email!= ''){

          regCheck(regEmail, this.createUserInfoForm.email,'邮箱格式不正确!');
        }
        stringIsNullOrEmpty(this.createUserInfoForm.gentle,'请选择性别!');
       
        stringIsNullOrEmpty(this.createUserInfoForm.deptId,'请选择团队!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      this.doCreateUserInfo();
    },
    // 创建用户
    doCreateUserInfo(){
      let url = "/bc/exa/usr/usrCreate"
      let param =  new FormData()
      param.append('fullName',this.createUserInfoForm.fullName)
      param.append('usrName', this.createUserInfoForm.usrName)
      param.append('deptId', this.createUserInfoForm.deptId)
      param.append('gentle', this.createUserInfoForm.gentle)
      param.append('email', this.createUserInfoForm.email)
      param.append('mobilePhone', this.createUserInfoForm.mobilePhone)
      let file = this.$refs[this.createUserInfoForm.refElUpload].uploadFiles[0]
      param.append('file',file.raw)
      axios.post(url, param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': this.userInfoFile.headers.token
        }
      }).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.createUserInfoDialogVisible= false
          this.clearCreateUserInfoForm()
          this.$message({
            showClose: true,
            message: '创建成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.userListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    // 关闭创建用户弹框
    clearCreateUserInfoForm(){
      if(this.$refs[this.createUserInfoForm.refElUpload] !=null ){
        this.$refs[this.createUserInfoForm.refElUpload].clearFiles()
      }
     
      this.createUserInfoForm.fullName = ''
      this.createUserInfoForm.usrName =''
      this.createUserInfoForm.gentle = ''
      this.createUserInfoForm.email = ''
      this.createUserInfoForm.mobilePhone = ''
      this.createUserInfoForm.deptId = ''
    },
   
   //创建试题删除一个图片
    handleRemove(file,refElUpload) {
      let fileList = this.$refs[refElUpload].uploadFiles
      let index = fileList.indexOf(file)
      this.$refs[refElUpload].uploadFiles.splice(index,1)
    },

    clearEditUserInfoForm(){
      this.userInfoForm.fileList.splice(0)
      if(this.$refs[this.userInfoForm.refElUpload] !=null ){
        this.$refs[this.userInfoForm.refElUpload].clearFiles()
      }
      this.userInfoForm.fullName = ''
      this.userInfoForm.usrName =''
      this.userInfoForm.gentle = ''
      this.userInfoForm.email = ''
      this.userInfoForm.mobilePhone = ''
      this.userInfoForm.deptId = ''
      this.userInfoForm.id = ''
      this.userInfoForm.updateImage = false
      this.userInfoForm.row = ''
    },

    funcUpdateImageChange(){
      let row = this.userInfoForm.row
      let rawHasFile = false
      if(row != null && row != '' && row.headImgUrl != null && row.headImgUrl != ''){
        rawHasFile = true
      }
      if(this.userInfoForm.updateImage){
        if( this.$refs[this.userInfoForm.refElUpload] != null){
          this.$refs[this.userInfoForm.refElUpload].clearFiles()
        }
        if(rawHasFile){
          this.userInfoForm.fileList.splice(0)
        }
      }else{
        if(rawHasFile){
          this.userInfoForm.fileList.push({name:row.usrName, url:row.headImgUrl})
        }
      }
    },
  
    clearSingRoleInfoFrom(){
      this.asignRoleInfoForm.roleList =[]
      this.asignRoleInfoForm.multipleSelection =[]
      this.asignRoleInfoForm.asignUserInfo = ''
    },
    
    handleEdit(index, row){
      this.dialogVisual.editUserInfoDialogVisible = true
      this.userInfoForm.fullName = row.fullName
      this.userInfoForm.updateImage = false
      this.userInfoForm.usrName = row.usrName
      this.userInfoForm.gentle = row.gentle
      this.userInfoForm.active = row.active
      this.userInfoForm.email = row.email
      this.userInfoForm.mobilePhone = row.mobilePhone
      this.userInfoForm.deptId = row.deptId
      this.userInfoForm.row = row
      if(row.headImgUrl!= null && row.headImgUrl != ''  ){
        this.userInfoForm.fileList.push({name:row.usrName, url:row.headImgUrl})
      }
      this.userInfoForm.id = row.id
    },
  
    ensureChange(){
      this.$confirm('即将更新用户['+this.userInfoForm.usrName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doChangeUserInfo()
      }).catch((e) => {
        this.$message({
          type: 'info',
          message: '取消更新！ '+ e
        });
      })
    },

    doChangeUserInfo(){
      try{
        if(this.userInfoForm.updateImage){
          let fileObj = this.$refs[this.userInfoForm.refElUpload]
          if(fileObj == null){
              throw '更新头像请选择头像1'
          }else{
             let fileList = fileObj.uploadFiles
             if(fileList == null || fileList.length == 0){
                throw '更新头像请选择头像2'
             }
          }
        }
        if (this.userInfoForm.email != null && this.userInfoForm.email != '') {
          regCheck(regEmail, this.userInfoForm.email,'邮箱格式不正确!');
        }
        if (this.userInfoForm.mobilePhone != null && this.userInfoForm.mobilePhone != '') {
          regCheck(regMobilePone, this.userInfoForm.mobilePhone,'手机号码格式不正确!')
        }
      }catch(e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let url = "/bc/exa/usr/usrEdit"
      let param =  new FormData()
      param.append('id',this.userInfoForm.id)
      param.append('fullName',this.userInfoForm.fullName)
      param.append('usrName', this.userInfoForm.usrName)
      param.append('deptId', this.userInfoForm.deptId)
      param.append('gentle', this.userInfoForm.gentle)
      param.append('email', this.userInfoForm.email)
      param.append('mobilePhone', this.userInfoForm.mobilePhone)
      if(this.userInfoForm.updateImage){
         let file = this.$refs[this.userInfoForm.refElUpload].uploadFiles[0]
         param.append('file',file.raw)
      }
      axios.post(url, param,{
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': this.userInfoFile.headers.token
        }}).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.editUserInfoDialogVisible= false;
            this.clearEditUserInfoForm();
            this.$message({
              showClose: true,
              message: '更新成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            setTimeout(()=>{this.userListLoad(1)},200)
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
   
    handleCurrentChange(val){
      this.userListLoad(val);
    },
 
    handleDelete(index, row){
      this.$confirm('即将删除用户['+row.usrName+']信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let dataBat = [];
        dataBat.push({id: row.id})
        this.doDeleteUserInfo(dataBat)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteUserInfo(dataBat){
      let url = "/bc/exa/usr/usrDelete"
      let s = JSON.stringify(dataBat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.userListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
      })
    },
    handleActive(index, row){
      let actState = row.active === 0 ? 1 : 0
      let dat = {
        id: row.id,
        active: actState
      }
      let url = "/bc/exa/usr/usrActive"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.userListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    fileUpLoadSuccess(response, file, fileList){
      this.$refs.upload.clearFiles();
      if(response.code === 0){
        this.$message({
          showClose: true,
          message: '上传成功!',
          type: 'success',
          duration: MESSAGE_DURATION
        })
      }else{
        this.$message({
          showClose: true,
          message: response.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      }
    },
    fileUpLoadError(err, file, fileList){
      this.$refs.upload.clearFiles();
      this.$message({
        showClose: true,
        message: err,
        type: 'error',
        duration: MESSAGE_DURATION
      })
    },
    templateDownLoad(){
      let outData = {}  //传参数据
      let url = "/bc/exa/usr/downloadExcel"; //接口
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = "blob";  // 返回类型blob
      xhr.setRequestHeader("Content-type", "application/json;charset=utf-8");
      xhr.setRequestHeader("token", this.userInfoFile.headers.token); //这个看后端接口情况决定要不要写
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      xhr.onload = function () {
          // 请求完成
          if (this.status === 200) {
              // 返回200
              var blob = this.response;
              const a = document.createElement('a');
              const url = window.URL.createObjectURL(blob);
              let reader = new FileReader();
              reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
              reader.onload = function (e) {
                  // 转换完成，创建一个a标签用于下载

                  let a = document.createElement('a');
                  a.download = '用户导入模板.xls';
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  // 修复firefox中无法触发click
                  a.click();
                  document.body.removeChild(a);
              }
          } else {
              layer.msg("下载失败：" + xhr.statusText, {
                  icon: 5,//成功的表情
                  time: 1000,
                  area: ['400px', '300px']
              })
          }
      };
      xhr.onerror = function () {
          layer.msg("下载失败：" + xhr.statusText, {
              icon: 5,//成功的表情
              time: 1000,
              area: ['400px', '300px']
          })
      }
      // 发送ajax请求
      xhr.send(JSON.stringify(outData))
    },
    handleRole(index, row){
      this.dialogVisual.signRoleDialogVisible = true
      this.asignRoleInfoForm.asignUserInfo = row
      let url = "/bc/exa/usr/getUsrRole"
      let data = {id : row.id}
      let s = JSON.stringify(data)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
              let resData = response.data.data
              if(resData.length !== 0){
                resData.forEach(t=> this.asignRoleInfoForm.roleList.push(t)) 
                this.asignRoleInfoForm.roleList.forEach(t=>{
                  if(t.LAY_CHECKED){
                    this.$refs.multipleTable.toggleRowSelection(t, true)
                  }
                })
              }else{
                this.$message({
                showClose: true,
                message: '未获取到数据!',
                type: 'warn',
                duration: MESSAGE_DURATION
              })
            }
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
      })
    },
    ensureSign(){
      let row = this.asignRoleInfoForm.asignUserInfo
      let list = this.asignRoleInfoForm.multipleSelection
      if (list == null || list.length == 0) {
        this.$confirm('您确定要清空用户['+row.usrName+']的角色信息吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doAssignRole(row.id,list);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已经取消清除角色信息！'
          });
        })
      } else {
        let ad = false;
        for (let i = 0; i < list.length; i++) {
          let li = list[i];
          if (roleType.admin == li.roleName) {
            ad = true;
            break;
          }
        }
        if (ad) {
          this.$confirm('您确定要赋予[' + row.fullName + ']超级管理员角色么？ ' +
            '系统中只能存在一个超级管理员,如果[' + row.fullName + ']不是您自己，' +
            '超级管理员会被置换成[' + row.fullName + '],' +
            '您将系统管理权转交给[' + row.fullName + ']', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doAssignRole(row.id,list);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已经取消分配角色！'
            });
          }) 
        } else {
            this.doAssignRole(row.id , list);
        }
      }
    },
    handleSelectionChange(val) {
      this.asignRoleInfoForm.multipleSelection = val;
    },
    doAssignRole(id, list){
      let url= "/bc/exa/usr/assignRole/" + id
      let s = JSON.stringify(list)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
            this.$message({
            showClose: true,
            message: '角色分配成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
      })
    },
    restPass(index, row){
      this.$confirm('您确定要重置用户['+row.usrName+']的密码么?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doRestPass(row);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已经取消重置用户密码!'
          });
        })
    },
    doRestPass(row){
      let url = "/bc/exa/usr/resetPass"
      let data = {id: row.id}
      let s = JSON.stringify(data)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '重置密码成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    }
  },
  created () {
    setTimeout(()=>{getToken(this.userInfoFile.headers)},200)
    this.deptListLoad();
    this.userListLoad(1);
  }
}
</script>
  
<style lang="less" scoped>
.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

</style>



// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_user.vue